import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import { renderTableTitle } from "@/utils/render.jsx";
import orgTreeModal from "@/components/Modal/orgTreeModal.vue";
import request from "@/service/identity.js";
export default {
  /*eslint-disable*/
  components: {
    orgTreeModal
  },
  data() {
    return {
      search: {
        keywords: "",
        org: []
      },
      identityList: [],
      currentRole: {}
    };
  },
  computed: {
    placeholder() {
      var _this$identityList$fi;
      let target = (_this$identityList$fi = this.identityList.find(item => {
        return this.currentRole.code === item.code;
      })) === null || _this$identityList$fi === void 0 ? void 0 : _this$identityList$fi.name;
      return $t("ea2dloj", "\u67E5\"${target}\"\u4E0B\u7684\u6210\u5458/\u90E8\u95E8", {
        "target": target
      });
    },
    columns() {
      const h = this.$createElement;
      return [{
        title: $t("eyrn2", "名称"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "targetName",
        notShowSearch: true,
        notShowForm: true,
        renderTable(h, {
          row
        }) {
          return h("div", {
            "class": "text-left"
          }, [row.targetName]);
        }
      }, {
        title: $t("cscota4", "所属部门"),
        key: "belongOrganizations",
        align: "left",
        notShowSearch: true,
        notShowForm: true,
        tooltip: true,
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        }
      }, {
        title: $t("f5g8b3", "操作人"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "createUserName",
        notShowSearch: true,
        notShowForm: true,
        tooltip: true
      }, {
        title: $t("d1tr1p4", "操作时间"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "createDatetime",
        notShowSearch: true,
        notShowForm: true
      }, {
        title: $t("hkxb2", "操作"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "action",
        width: 120,
        notShowSearch: true,
        notShowForm: true,
        renderTable: (h, {
          row
        }) => {
          return h("a", {
            "class": "text-[var(--secondary,#785a1a)] hover:underline cursor-pointer",
            "on": {
              "click": async () => {
                this.deleteMember(row);
              }
            }
          }, [$t("lknd2", "移除")]);
        }
      }];
    },
    height() {
      return window.innerHeight - 250;
    },
    toolBarActions() {
      const h = this.$createElement;
      return [{
        renderItem: () => {
          return h("Button", {
            "attrs": {
              "type": "primary"
            },
            "on": {
              "click": async () => {
                this.addMember();
              }
            }
          }, [$t("e7yhal4", "添加成员")]);
        }
      }];
    },
    config() {
      return {
        //配置项
        autoFetch: false,
        columns: this.columns,
        hide: {
          search: true
        },
        table: {
          border: false,
          draggable: false,
          height: this.height
        },
        toolBarActions: this.toolBarActions,
        //   search: false,
        request: async params => {
          let {
            datas,
            firstResult = 0,
            pageSize = 10,
            totalRows = 0
          } = await this.getTableData(params);
          return {
            list: datas || [],
            pageNum: firstResult / pageSize + 1,
            pageSize,
            total: totalRows
          };
        },
        map: {
          dataPath: "list",
          totalPath: "total",
          current: "pageNum",
          pageSize: "pageSize"
        }
        // hide: { toolBar: true },
      };
    }
  },
  methods: {
    addMember() {
      this.$refs["orgTreeModalRef"].open([]);
    },
    selectMenu(role) {
      this.currentRole = role;
      this.$refs.proTableRef.fetch();
    },
    searchTable() {
      // this.$refs.proTableRef.searchReset({ current: 1, pageSize: 10 });
      this.$refs.proTableRef.searchAction();
    },
    async getfindIdentityPage() {
      let params = {
        pageSize: 99999,
        firstResult: 0,
        search: this.search.keywords,
        unitId: ""
      };
      let {
        data: {
          retVal: {
            datas
          }
        }
      } = await request.findIdentityPage(params);
      this.identityList = datas;
      this.selectMenu(datas[0]);
    },
    async getTableData(info) {
      console.log(info);
      let {
        uuid
      } = this.currentRole;
      let {
        pageNum
      } = info;
      let {
        keywords
      } = this.search;
      let params = {
        search: keywords,
        ...info,
        firstResult: info.pageSize * (pageNum - 1),
        identityId: uuid
      };
      let {
        data: {
          retVal: {
            datas,
            firstResult = 0,
            pageSize = 1,
            totalRows
          }
        }
      } = await request.identityUserRelationPage(params);
      return {
        datas,
        firstResult,
        pageSize,
        totalRows
      };
    },
    async assignIdentity(value) {
      let {
        uuid
      } = this.currentRole;
      let userIds = [];
      let orgIds = [];
      value.forEach(item => {
        let {
          type
        } = item;
        if (type === "USER") {
          userIds.push(item.key);
        }
        if (type === "ORG") {
          orgIds.push(item.key);
        }
      });
      let params = {
        userIds,
        orgIds,
        identityUuids: [uuid]
      };
      let {
        data: {
          result,
          retVal
        }
      } = await request.assignIdentity(params);
      if (result === 0) {
        this.$Message.success($t("ay71ee4", "分配成功"));
      } else {
        this.$Message.error(retVal);
      }
      // userIds
      this.$refs.proTableRef.fetch();
    },
    deleteMember(item) {
      this.$Modal.confirm({
        title: $t("frotru4", "确认删除") + "?",
        onOk: async () => {
          let {
            targetId,
            targetType
          } = item;
          let {
            uuid
          } = this.currentRole;
          let {
            data: {
              result,
              msg
            }
          } = await request.removeUserIdentity({
            targetId: targetId,
            identityId: uuid,
            targetType
          });
          if (result === 0) {
            let proTableRef = this.$refs["proTableRef"];
            if (proTableRef.proData.length === 1 && proTableRef.page.current > 1) {
              proTableRef.page.current -= 1;
            }
            this.$refs["proTableRef"].fetch();
            this.$Message.success(msg);
          }
        }
      });
    }
  },
  mounted() {
    this.getfindIdentityPage();
  }
};